import { connect } from 'react-redux';
import { logout } from './../../../actions/auth';
import Component from './NavigationBar';

export default connect(
  state => ({
    manageSettings: state.auth.rbac.manageSettings,
    manageManagers: state.auth.rbac.manageManagers,
    user: state.auth.user,
    clubSettings: state.clubSettings
  }),
  //Dispatches
  dispatch => ({
    logout: () => dispatch(logout())
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/LoggedLayout/NavigationBar/index.js